import { PaymentService } from '@/service/PaymentService'
import { useAppStore } from '@/store/app'
import { useProductListStore } from '@/store/productListStore'
import { ref } from 'vue'
import { useRoute } from 'vue-router'

const loading = ref(false)
export const usePayment = () => {
  const route = useRoute()
  const appStore = useAppStore()

  const getCurrencyDetails = async () => {
    const productListStore = useProductListStore()
    try {
      loading.value = true
      if (Object.keys(productListStore.currencyDetails).length === 0) {
        const { data } = await PaymentService.getCurrencyDetails()
        if (data && data.currency) {
          productListStore.setCurrencyDetails(data)
        }
      }
    } catch (error) {
      console.error(error)
    } finally {
      loading.value = false
    }
  }

  const fetchPaymentIntegrations = async () => {
    try {
      const { data } = await PaymentService.fetchPaymentIntegrations(route.params.locationId as string)
      if (data.defaultPaymentProvider) {
        appStore.setPaymentIntegrations(data)
      }
    } catch (error) {
      console.error(error)
    } finally {
      loading.value = false
    }
  }

  const fetchPaymentSettings = async (locationId: string) => {
    try {
      loading.value = true
      const { data } = await PaymentService.fetchPaymentSettings(locationId)
      return data
    } catch (error) {
      console.error(error)
    } finally {
      loading.value = false
    }
  }

  return {
    getCurrencyDetails,
    fetchPaymentIntegrations,
    fetchPaymentSettings,
  }
}
